export default "https://cdn-static.gokick.com/assets/16eea26e4b02b6fb7531e57480884e04972270e8/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";